import { useState, useEffect } from 'react';
import { AdminAuthService } from '../services/admin/auth.service';

export const useAdminAuth = () => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const adminData = sessionStorage.getItem('adminData');
    const token = sessionStorage.getItem('adminToken');

    if (adminData && token) {
      const isValid = AdminAuthService.verifyToken(token);
      if (isValid) {
        setAdmin(JSON.parse(adminData));
      } else {
        // Token invalide, nettoyer le stockage
        sessionStorage.removeItem('adminToken');
        sessionStorage.removeItem('adminData');
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const { token, admin } = await AdminAuthService.login(username, password);
      sessionStorage.setItem('adminToken', token);
      sessionStorage.setItem('adminData', JSON.stringify(admin));
      setAdmin(admin);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const logout = () => {
    sessionStorage.removeItem('adminToken');
    sessionStorage.removeItem('adminData');
    setAdmin(null);
  };

  const isSuperAdmin = () => {
    return admin?.role === 'superAdmin';
  };

  return {
    admin,
    loading,
    login,
    logout,
    isSuperAdmin
  };
}; 